import React, { useState, useEffect, useRef } from "react";
import * as Styled from "./styles";
import Select from "Components/Form/Inputs/Select";
import { white } from "Components/Form/Inputs/Select/themes";
import ResizeObserver from "resize-observer-polyfill";

const letters = [
  { name: "A-Z", value: "" }, // Adiciona a opção "A-Z" com valor vazio
  ...[
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ].map(letter => ({
    name: letter,
    value: letter,
  })),
];

interface Props {
  setSelected: React.Dispatch<React.SetStateAction<string | null>>;
  selected: string | null;
  hideSearch?: boolean;
}

export const FilterByLetter: React.FC<Props> = ({
  selected,
  setSelected,
  hideSearch,
}) => {
  const selectRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const selectEl = selectRef.current;
    const containerEl = containerRef.current;
    if (!selectEl || !containerEl) return;

    const observer = new ResizeObserver(entries => {
      const height = entries[0].contentRect.height;
      containerEl.style.maxHeight = `${height + 16}px`; // padding extra
    });

    observer.observe(selectEl);

    return () => observer.disconnect();
  }, []);

  const renderSelect = () => (
    <Select
      // ref={selectRef}
      hideSearch={hideSearch}
      change={value => setSelected(value)}
      name="letters"
      options={letters}
      defaultValue={letters[0].value}
      theme={white}
      newSelect={true}
    />
  );

  return (
    <Styled.Container
      hideSearch={hideSearch}
      // ref={containerRef}
      id="filterByLetterContainer"
    >
      {renderSelect()}
    </Styled.Container>
  );
};

export default FilterByLetter;
